module.exports = __webpack_public_path__ + "static/media/Group79.253eb715.png";